import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const axios_instance = axios.create({
    baseURL: BASE_URL + "/",
});

//getting home Content
export const getHomeContent = async () => {
    try {
        const linksResponse = await axios_instance.get("/links");
        const announcementsResponse = await axios_instance.get(
            "/announcements"
        );
        const quotesResponse = await axios_instance.get("/quotes");

        return {
            links: linksResponse.data.links,
            announcements: announcementsResponse.data.announcements,
            quotes: quotesResponse.data.quotes,
        };
    } catch (err) {
        console.log(err);
        return [];
    }
};
//gettting resources/images/events

export const getResources = async () => {
    try {
        const response = await axios_instance.get("/resources");
        return response.data.resources;
    } catch (err) {
        console.log(err.message);
        return [];
    }
};

export const getImages = async () => {
    try {
        const response = await axios_instance.get("/gallery");
        return response.data.images;
    } catch (err) {
        console.log(err.message);
        return [];
    }
};

export const getEvents = async () => {
    try {
        const response = await axios_instance.get("/events");
        return response.data.events;
    } catch (err) {
        console.log(err.message);
        return [];
    }
};

// getting individual events/resources

export const getResource = async (id) => {
    try {
        const response = await axios_instance.get("/resources/single/" + id);
        return response.data.resource;
    } catch (err) {
        console.log(err.message);
        return [];
    }
};

export const getEvent = async (id) => {
    try {
        const response = await axios_instance.get("/events/single/" + id);
        return response.data.event;
    } catch (err) {
        console.log(err.message);
        return [];
    }
};

// getting teams information

export const getTeams = async () => {
    try {
        const response = await axios_instance.get("/persons");
        const groupBy = (key) => (array) =>
            array.reduce((objectsByKeyValue, obj) => {
                const value = obj[key];
                objectsByKeyValue[value] = (
                    objectsByKeyValue[value] || []
                ).concat(obj);
                return objectsByKeyValue;
            }, {});
        return groupBy("batch")(response.data.persons);
    } catch (err) {
        console.log(err.message);
        return [];
    }
};

// getting trending links

export const getTrendingLinks = async () => {
    try {
        const response = await axios_instance.get("/links");
        return response.data.links;
    } catch (err) {
        console.log(err);
        return [];
    }
};

export const getQuotes = async () => {
    try {
        const response = await axios_instance.get("/quotes");
        return response.data.quotes;
    } catch (err) {
        console.log(err.message);
        return [];
    }
};

export const getAnnouncements = async () => {
    try {
        const response = await axios_instance.get("/announcements");
        return response.data.announcements;
    } catch (err) {
        console.log(err.message);
        return [];
    }
};
